import { IconComponent } from '../Icon/IconComponent';
import styles from './Button.module.css';

export const Button = ({
  children,
  onClick,
  type,
  buttonType,
  buttonStyleType = 'default',
  disabled = false,
  icon,
  iconType,
  iconStyleType,
  iconPosition = 'left',
  animatedIcon = false,
}) => {
  const buttonStyles = {
    primaryAction: styles.primaryAction,
    primary: styles.primary,
    secondary: styles.secondary,
    tertiaryBlack: styles.tertiaryBlack,
    tertiaryWhite: styles.tertiaryWhite,
    tertiaryGray: styles.tertiaryGray,
    printBanner: styles.printBanner,
    printDefault: styles.printDefault,
    clearFormField: styles.clearFormField,
    circleButton: styles.circleButton,
    default: styles.default,
  };

  const buttonStyle = buttonStyles[buttonStyleType] || buttonStyles.default;

  const resolvedButtonType = type || buttonType || 'button';

  const handleClick = (event) => {
    if (disabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    if (onClick) {
      onClick(event);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`${buttonStyle} ${disabled ? styles.disabled : ''}`}
      disabled={disabled}
      aria-disabled={disabled}
      type={resolvedButtonType}
    >
      {icon && iconPosition === 'left' && (
        <span className={`${styles.icon} ${animatedIcon ? styles.animated : ''}`}>
          <IconComponent iconStyleType={iconStyleType} iconType={iconType}>
            {icon}
          </IconComponent>
        </span>
      )}

      <span>{children}</span>

      {icon && iconPosition === 'right' && (
        <span className={`${styles.icon} ${styles['icon-right']} ${animatedIcon ? styles.animated : ''}`}>
          <IconComponent iconStyleType={iconStyleType} iconType={iconType}>
            {icon}
          </IconComponent>
        </span>
      )}
    </button>
  );
};